import { render, staticRenderFns } from "./initBargainSuccess.vue?vue&type=template&id=6fb0219a&scoped=true"
import script from "./initBargainSuccess.vue?vue&type=script&lang=js"
export * from "./initBargainSuccess.vue?vue&type=script&lang=js"
import style0 from "./initBargainSuccess.vue?vue&type=style&index=0&id=6fb0219a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb0219a",
  null
  
)

export default component.exports